import { Navigate, Route, Routes } from 'react-router-dom';
import React, { ComponentType, ReactElement } from 'react';
import { RouteConfig } from '@bobex/react-core/routes/RouteConfig';
import AuthorityGuard from '@bobex/react-core/routes/AuthorityGuard';
import AppRoute from '@bobex/react-core/routes/AppRoute';

interface AllRoutesProps {
  loginPage: ReactElement;
  authenticatedEntryPath: string;
  protectedRoutes?: RouteConfig[];
  appLayout: ComponentType<any>;
}

const AllRoutes = ({
  loginPage,
  appLayout: AppLayoutComponent,
  authenticatedEntryPath,
  protectedRoutes,
}: AllRoutesProps) => {
  return (
    <Routes>
      {/* Redirection de la racine vers l'entrée authentifiée */}
      <Route path="/" element={<Navigate replace to={authenticatedEntryPath} />} />

      {/* Page de login */}
      <Route path="/login" element={loginPage} />

      {/* Layout de l'application avec nested routes */}
      <Route path="/*" element={<AppLayoutComponent />}>
        {(protectedRoutes ?? []).map((route, index) => (
          <Route
            key={`${route.key}-${index}`}
            path={route.path}
            element={
              <AuthorityGuard authority={route.authority}>
                <AppRoute routeKey={route.key} component={route.component} />
              </AuthorityGuard>
            }
          />
        ))}
        {/* Fallback 404 sous le layout */}
        <Route path="*" element={<>404</>} />
      </Route>
    </Routes>
  );
};

export default AllRoutes;
